import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import decode from "jwt-decode";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
const Header = () => {
  const history = useHistory();
  const location = useLocation();
  const [name, setName] = useState("");
  const dispatch = useDispatch();
  // const [userToken, setUserToken] = useState(
  //   JSON.parse(localStorage.getItem("SessionID"))
  // );
  const user = useSelector((state) => state.session);

  const logout = () => {
    history.push("/login");
    dispatch({ type: "LOGOUT" });
    toast.error("Session expired. Please login again");
  };

  useEffect(() => {
    const token = user?.accessToken;
    if (token) {
      try {
        const decodedToken = decode(token);
        if (!decodedToken) return logout();
        if (decodedToken.exp * 1000 < new Date().getTime()) logout();
      } catch (error) {
        logout();
      }
    }
  }, [location]);

  return (
    <>
      <ToastContainer autoClose={3000} position="bottom-center" />
      <nav className="header">
        <ul className="header-ul widthContainer">
          <li className="header-title">
            <Link to="/" className="header-link">
              <h1>Blog V1</h1>
            </Link>
          </li>

          <li className="header-li">
            <Link to="/article/publish" className="header-link">
              Publish
            </Link>
          </li>
          <li className="header-li">
            <a href="/articles-list/articles" className="header-link">
              Articles
            </a>
          </li>
          <li className="header-li">
            {user?.accessToken ? (
              <Link
                to={`/account/articles/${decode(user?.accessToken).id}`}
                className="header-link "
              >
                {`Hi, ${decode(user?.accessToken).name.split(" ")[0]}`}
              </Link>
            ) : (
              <Link to="/login" className="header-link ">
                Login
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Header;
